(function () {
    'use strict';

    angular.module("imApp").factory("subscriptionUsergroupEditService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 112,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 113,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
